<ng-container>
	<caroo-resource [resource]="resource" [fallback]="fallback"></caroo-resource>
	<ng-content select="caroo-activity-indicator"></ng-content>
</ng-container>
